<script lang="ts">
  import { Button, TextInput } from 'carbon-components-svelte'
  import Chat from 'carbon-icons-svelte/lib/Chat20'
  import GameStore from '../stores/games'

  export let gameId: number

  let composingMessage = ''
  const chatMessages = GameStore.chatMessages(gameId)

  function pressKey(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      sendMessage()
    }
  }
  function sendMessage() {
    const messageToSend = composingMessage.trim()
    if (messageToSend) {
      GameStore.sendChatMessage(messageToSend, gameId)
      composingMessage = ''
    }
  }
  function setInitialPixelHeight(node: HTMLDivElement) {
    node.scrollTop = 100
  }
</script>

<div class="game-chat">
  <Button icon={Chat}>
    Game Chat ({0})
  </Button>
  <div class="game-chat__body">
    <div class="game-chat__messages" use:setInitialPixelHeight>
      {#each $chatMessages as message}
        <div class="game-chat__message">
          {#if 'senderName' in message}
            <b>{message.senderName}</b>
            <span>{message.message}</span>
          {:else}
            <em>{message.message}</em>
          {/if}
        </div>
      {/each}
      <div class="game-chat__anchor" />
    </div>
    <div class="game-chat__composer">
      <TextInput
        placeholder="Compose message"
        on:keydown={pressKey}
        bind:value={composingMessage}
      />
    </div>
  </div>
</div>

<style>
  .game-chat {
    width: 18rem;
    align-self: stretch;
    display: flex;
    flex-direction: column;
  }
  :global(.game-chat > button) {
    width: 100%;
  }

  .game-chat__body {
    flex-grow: 1;
    width: 100%;
    background-color: var(--cds-field-01, #f4f4f4);
    display: flex;
    flex-direction: column;
    margin-bottom: 3rem;
  }
  .game-chat__messages {
    flex-grow: 1;
    overflow-y: scroll;
  }
  .game-chat__messages * {
    overflow-anchor: none;
  }
  .game-chat__messages::after {
    content: '';
    height: 1px;
    display: block;
    overflow-anchor: auto;
  }
  .game-chat__message {
    padding: 0.2rem;
    line-height: 1.2;
    line-break: anywhere;
  }
  .game-chat__message b {
    font-weight: 700;
  }
  :global(.game-chat__composer input) {
    margin-bottom: 0;
    border-top: 1px solid var(--cds-ui-04, #8d8d8d);
    border-bottom: none;
  }
</style>
